import { render, staticRenderFns } from "./decouverte.vue?vue&type=template&id=5fea4fdb&scoped=true"
import script from "./decouverte.vue?vue&type=script&lang=js"
export * from "./decouverte.vue?vue&type=script&lang=js"
import style0 from "./decouverte.vue?vue&type=style&index=0&id=5fea4fdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea4fdb",
  null
  
)

export default component.exports